export const ClockIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
			<circle cx="20" cy="20" r="18" fill="#262A2F" />
			<path d="M2 20C2 29.9411 10.0589 38 20 38V2C10.0589 2 2 10.0589 2 20Z" fill="url(#paint0_linear_169_218)" />
			<path
				d="M26.4286 24.7143L20 20V8.85718"
				stroke="white"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_169_218"
					x1="1.80057e-08"
					y1="24"
					x2="18.9563"
					y2="23.0896"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
}
